import React, { useState, useEffect } from "react"
import '../styles/components/Menu.css'
import '../App.css'

const Menu = () => {
    const [navbar, setNavbar] = useState(false)
    const [Mobile, setMobile] = useState(false)

    const changeBackground = () => {
        if (window.scrollY >= 510) {
            setNavbar(true)
        } else {
            setNavbar(false)
        }
    }

    useEffect(() => {
        changeBackground()
        // adding the event when scroll change background
        window.addEventListener("scroll", changeBackground)
    })

    return (
        <>
            <div className={(navbar||Mobile)? "header active" : "header"}>
                <div className="logo"></div>
                <div className='nav'>
                    <div className={Mobile ? "menu-icon open" : "menu-icon"} onClick={() => setMobile(!Mobile)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <nav className= {Mobile ? "myLinks-mobile" : "myLinks"}  onClick={() => setMobile(false)}>
                        <ul>
                            <a className="link" href="/"><li>الصفحة الرئيسية</li></a>
                            <a className="link" href="/about"><li>من أنا</li></a>
                            <a className="link" href="/blog"><li>المدونة</li></a>
                            <a className="link" href="/contact"><li>تواصل معي </li></a>
                            <a className="link button" href="/ask"><li> اسألني</li></a>
                        </ul>
                    </nav>
                </div>
            </div>
            <div className="landing" style={{display: 'none'}}>
                <div className='intro'>
                    <h1>الخطـوة الأولـى
                        هي سـر المضـي قدمًا!<br/><br/>حدد هدفك وأكمل..</h1>
                    <a className="button">تواصل معي</a>
                </div>

            </div>
        </>
    );
}

export default Menu;